﻿export default class CustomElementFactory extends HTMLElement {
    constructor() {
        super();
        this.listeners = [];
    }

    connectedCallback() {}

    /**
     * If the custom element is getting removed of the dom, all listeners
     * are getting removed of the element.
     */
    disconnectedCallback() {
        this.listeners.forEach((item) => {
            item.element.removeEventListener(item.event, item.action);
        });
    }

    /**
     * Here you can push a listener object directly to the listener array
     *
     * @param {Listener} {}
     */
    pushListener({ event, element, action }) {
        this.listeners.push({ event, element, action });
        element.addEventListener(event, action);
    }

    /**
     * Removes the given element from the listener array and removes the
     * EventListener from the element and returns the listener object.
     * If the element was not found, undefined is returned.
     *
     * @param {Element} element
     * @returns {Listener | undefined}
     */
    removeListener(element) {
        const foundElement = this.listeners.find((item) => item.element === element);
        if (!foundElement) return;
        foundElement.element.removeEventListener(foundElement.event, foundElement.action);
        const newList = this.listeners.filter((item) => item.element !== element);
        this.listeners = newList;
        return foundElement;
    }
}